// オンラインセールスデモ （社員側）
// ToDo: ログアウトボタンの詳細は未実装
// ToDo: プライベートチャンネルから出たときに出るワーニングをシュート
// ToDo: 通信が切れたときの処理とか
// ToDo: いろんな例外処理とか
// ToDo: userInfoオブジェクトの使い方もう少し洗練できないかな。
// ToDo: Tokenは外部で作らないとね

import { nowInSec, SkyWayAuthToken, SkyWayChannel, SkyWayContext, SkyWayStreamFactory, uuidV4 } from "@skyway-sdk/core";
import { appId, secret } from "./env";
let robbyMe;
const token = new SkyWayAuthToken({
  jti: uuidV4(),
  iat: nowInSec(),
  exp: nowInSec() + 60 * 60 * 24,
  scope: {
    app: {
      id: appId,
      turn: true,
      actions: ["read"],
      channels: [{
        id: "*",
        name: "*",
        actions: ["write"],
        members: [{
          id: "*",
          name: "*",
          actions: ["write"],
          publication: {
            actions: ["write"]
          },
          subscription: {
            actions: ["write"]
          }
        }],
        sfuBots: [{
          actions: ["write"],
          forwardings: [{
            actions: ["write"]
          }]
        }]
      }]
    }
  }
}).encode(secret);
const ringTone = new Audio("ringtone.mp3");
ringTone.loop = true;
ringTone.preload = "auto";

// DBUGフラグ
const _DEBUG_ = false;

// 定数
const _RobbyName_ = "Robby"; // ロビーのチャンネル名
const _GuestButtonClassName_ = "invitationButton"; // 相談者（ゲスト）ボタンのクラス名。CSSで定義されるクラス名と同じものにすること。
var audioTemp;
var shareScree;

// オブジェクトに後から何でも入れられるようにワントリック

// ユーザ諸元格納用オブジェクト
const userInfo = {};

// デバグ用 userInfo 表示
const _checkUserInfo = () => {
  if (_DEBUG_) console.table(userInfo);
};

// 相談用のチャンネルのIDを生成する
const generateUUID = () => {
  const timeStamp = Date.now().toString(16);
  const randomHex = Math.floor(Math.random() * 0xffffff).toString(16);
  return `${timeStamp}-${randomHex}`;
};

// ここから
void (async () => {
  // HTMLの各要素を取得 使ってないものもあるけどそれはまぁおいおい
  const roleChoices = document.getElementsByName("role-choice");
  const logInName = document.getElementById("log-in-name");
  const logInButton = document.getElementById("log-in-button");
  const logOutButton = document.getElementById("log-out-button");
  const localVideo = document.getElementById("local-video");
  const remoteMediaArea = document.getElementById("remote-media-area");
  const remoteVideoArea = document.getElementById("remote-video-area");
  const remoteAudioArea = document.getElementById("remote-audio-area");
  const selfInfoText = document.getElementById("self-info-text");
  const buttonArea = document.getElementById("button-area");
  const screenShareButton = document.getElementById("screen-share");
  const privateChannelButtonArea = document.getElementById("private-channel-button-area");
  const privateChannelCloseButton = document.getElementById("private-channel-close-button");
  const chatArea = document.getElementById("chat-area");
  const chatInput = document.getElementById("chat-input");
  const chatButton = document.getElementById("chat-send-button");
  const screenShareInfo = document.getElementById("screen-share-info");
  let privateMe;
  let privateContext;
  let privateChannel;

  // プライベートチャネル終話ボタンを隠す
  privateChannelButtonArea.style.display = "none";

  // オーディオ、ビデオストリームストリーム作成 自分のカメラ画像を画面に表示
  var {
    audio,
    video
  } = await SkyWayStreamFactory.createMicrophoneAudioAndCameraStream();
  video.attach(localVideo);
  await localVideo.play();

  // データストリームの作成
  const dataStream = await SkyWayStreamFactory.createDataStream();
  const dataStreamPrivate = await SkyWayStreamFactory.createDataStream();
  const init = () => {
    //------------------------------------------- 起動時処理定義
    logOutButton.disabled = true;
    screenShareButton.disabled = true;
    screenShareInfo.style.display = "none";
  }; // ------------------------------------------------------------- 起動時処理 末尾

  logInButton.onclick = async () => {
    //---------------------------------- ログインボタン処理

    // ログイン名入ってないと入れないよ
    if (logInName.value === "") {
      return;
    }

    // user諸情報を入れる
    userInfo.name = logInName.value;
    const _employeeId = logInName.value;
    // 今回は２択だから三項演算子で楽をする
    userInfo.role = "counselor";
    userInfo.roleText = "セールス担当";
    selfInfoText.textContent = userInfo.name + "(" + userInfo.roleText + ")";

    // ロビーチャンネルに入る準備
    let robbyName = _RobbyName_ + "-" + _employeeId;
    const robbyContext = await SkyWayContext.Create(token);
    const robbyChannel = await SkyWayChannel.FindOrCreate(robbyContext, {
      name: robbyName
    });

    // ロビーチャンネルに入る
    robbyMe = await robbyChannel.join();
    userInfo.robbyMeId = robbyMe.id;
    userInfo.room = "robby";
    // ロビーチャンネルにはデータストリームだけをパブリッシュ
    await robbyMe.updateMetadata(JSON.stringify(userInfo));
    await robbyMe.publish(dataStream);

    // ロビーに居る人のボタン作成
    const robbyMembersButton = async () => {
      if (userInfo.role == "guest") return; // ロビーの人のボタンが出るのは相談者の場合のみ
      // ここで、ボタンエリアを一回綺麗にしておかないとボタンが蓄積してえらいことに
      const memberButtons = document.getElementsByClassName(_GuestButtonClassName_);
      if (memberButtons.length > 0) {
        while (memberButtons.length) {
          memberButtons.item(0).remove();
        }
      }
      for (const robbyMember of robbyChannel.members) {
        if (robbyMember.type == "person") {
          // 人だけ、Botはお断り
          const memberMeta = JSON.parse(robbyMember.metadata);
          if (memberMeta.robbyMeId != robbyMe.id && memberMeta.role == "guest") {
            // ここでゲスト（相談者）のボタンを作成 相談員のボタンは作らない
            const inviteButton = document.createElement("button");
            inviteButton.name = memberMeta.name;
            inviteButton.textContent = memberMeta.name;
            inviteButton.value = memberMeta.robbyMeId;
            inviteButton.classList.add(_GuestButtonClassName_);
            buttonArea.appendChild(inviteButton);
            if (memberMeta.callStatus === "calling") {
              ringTone.play();
            }
            inviteButton.onclick = () => {
              sendInvitation(inviteButton.value);
            };
          }
        }
      }
    }; // ロビーにいる人のボタン作成 末尾

    // ゲストをプライベート相談室に招待する。 相談員しか使わないメソッド
    const sendInvitation = async guestId => {
      // 招待する相談室を作ってログイン
      const privateChannelName = generateUUID();
      privateContext = await SkyWayContext.Create(token);
      privateChannel = await SkyWayChannel.FindOrCreate(privateContext, {
        name: privateChannelName
      });
      privateMe = await privateChannel.join();
      userInfo.room = "private";
      userInfo.privateChannelName = privateChannelName;
      userInfo.privateChannelMeId = privateMe.id;
      privateMe.publish(audio);
      privateMe.publish(dataStreamPrivate);
      privateMe.publish(video, {
        metadata: "mainVideo"
      });

      // 画面共有ボタンを利用可能に
      screenShareButton.disabled = false;

      // 招待状をしつらえる
      const inviteTimestamp = new Date();
      const invitationLetter = {
        type: "invite",
        iviteDate: inviteTimestamp,
        channel: userInfo.privateChannelName,
        host: userInfo.robbyMeId,
        hostPrivate: userInfo.privateChannelMeId,
        guest: guestId
      };
      if (_DEBUG_) console.table(userInfo);
      if (_DEBUG_) console.log("INVITATION LETTER");
      if (_DEBUG_) console.table(invitationLetter);
      dataStream.write(JSON.stringify(invitationLetter));

      // ユーザ選択ボタンを隠して、相談室終話ボタンを表示
      buttonArea.style.display = "none";
      privateChannelButtonArea.style.display = "block";
      // 相談チャンネル退出時のイベントを設定
      privateChannel.onMemberLeft.add(e => onPrivateMemberLeft(e.member));
      privateChannel.publications.forEach(subscribeAndAttacheInPrivateChannel);
      privateChannel.onStreamPublished.add(e => subscribeAndAttacheInPrivateChannel(e.publication));
    };

    // 相談チャンネル退出時のイベントの実態
    const onPrivateMemberLeft = async member => {
      console.log("member has left from PrivateChannel:", member);
      console.log("left memberId:", member.id);
      console.log("my privateId:", userInfo.privateChannelMeId);
      const guestVideoPlayer = document.getElementById("guestVideoPlayer");
      const guestAudioPlayer = document.getElementById("guestAudioPlayer");
      disposeVideoElement(guestVideoPlayer);
      disposeAudioElement(guestAudioPlayer);
      privateMe.leave();
      privateContext = null;
      privateChannel = null;
      userInfo.privateChannelName = "";
      userInfo.privateChannelMeId = "";

      // ボタンを初期化
      if (userInfo.role == "guest") {
        buttonArea.style.display = "none";
        privateChannelButtonArea.style.display = "none";
      } else {
        buttonArea.style.display = "block";
        privateChannelButtonArea.style.display = "none";
      }
    };

    // 相談チャンネルからの退出 （通話終了ボタンクリック時)
    privateChannelCloseButton.onclick = async () => {
      console.log("left from private Channel");
      console.log(privateMe);
      //これで実際に相談チャンネルから抜ける
      privateMe.leave();
      // 自分のところは自分でキレイに
      const guestVideoPlayer = document.getElementById("guestVideoPlayer");
      const guestAudioPlayer = document.getElementById("guestAudioPlayer");
      disposeVideoElement(guestVideoPlayer);
      disposeAudioElement(guestAudioPlayer);
      privateContext = null;
      privateChannel = null;

      // ボタンを初期化
      if (userInfo.role == "guest") {
        buttonArea.style.display = "none";
        privateChannelButtonArea.style.display = "none";
      } else {
        buttonArea.style.display = "block";
        privateChannelButtonArea.style.display = "none";
      }
    };

    // Videoエレメントの削除
    const disposeVideoElement = async killRemoteVideo => {
      const killStream = killRemoteVideo.srcObject;
      killStream.getTracks().forEach(track => track.stop());
      killRemoteVideo.srcObject = null;
      killRemoteVideo.remove();
    };

    // Audioエレメントの削除
    const disposeAudioElement = async killRemoteAudio => {
      if (userInfo.role == "guest") {
        const killStream = killRemoteAudio.srcObject;
        killStream.getTracks().forEach(track => track.stop());
      }
      killRemoteAudio.srcObject = null;
      killRemoteAudio.remove();
    };

    // 相談チャンネルの振る舞い
    const subscribeAndAttacheInPrivateChannel = publication => {
      if (publication.publisher.id === privateMe.id) return;
      void (async () => {
        const privateStream = await privateMe.subscribe(publication.id);
        switch (privateStream.stream.contentType) {
          case "video":
            {
              const elm = document.createElement("video");
              elm.id = "guestVideoPlayer";
              elm.style.width = "700px";
              elm.playsInline = true;
              elm.autoplay = true;
              privateStream.stream.attach(elm);
              remoteVideoArea.appendChild(elm);
            }
            break;
          case "audio":
            {
              const elm = document.createElement("audio");
              elm.id = "guestAudioPlayer";
              elm.controls = true;
              elm.autoplay = true;
              privateStream.stream.attach(elm);
              remoteAudioArea.appendChild(elm);
            }
            break;
          case "data":
            {
              privateStream.stream.onData.add(data => {
                const msg = JSON.parse(data);
                console.table(data);
                if (msg.type === 'chat') {
                  chatArea.insertAdjacentHTML('beforeend', '<p class=otherTxt>' + msg.data + '</p>');
                  chatArea.scrollTop = chatArea.scrollHeight;
                }
              });
            }
        }
      })();
    };

    // ロビーでのデータストリームのサブスクライブ
    const subscribeAndAttacheInRobby = async publication => {
      if (publication.publisher.id === robbyMe.id) return;
      robbyMembersButton();
      const {
        stream
      } = await robbyMe.subscribe(publication.id);

      // DataStreamしかこないから、とおもって、switch-case文を入れずに
      // いきなり stream.onData ってやると怒られる (なぜ？)
      switch (stream.contentType) {
        case "video":
          break;
        case "audio":
          break;
        case "data":
          stream.onData.add(data => {
            // データストリームでデータを受け取ったときの処理
            const msg = JSON.parse(data); // JSONデータをオブジェクトに

            console.table(data);
            if (msg.type === "invite" && msg.guest == userInfo.robbyMeId) {
              joinPrivateChannel(msg);
            }
          });
      }
    };

    // チャットボタンの処理
    chatButton.onclick = () => {
      console.log("Chat Button Clicked");
      const msg = {
        type: "chat",
        data: chatInput.value
      };
      chatArea.insertAdjacentHTML('beforeend', '<p class=myTxt>' + chatInput.value + '</p>');
      chatArea.scrollTop = chatArea.scrollHeight;
      dataStreamPrivate.write(JSON.stringify(msg));
      chatInput.value = "";
    };

    // 画面共有ボタンの処理
    screenShareButton.onclick = async () => {
      console.log("ScreenShare Button Clicked");
      var {
        audioTemp,
        video
      } = await SkyWayStreamFactory.createDisplayStreams();
      privateMe.publish(video, {
        metadata: "screenShare"
      });
      //画面共有が終わったときの処理
      video.onDestroyed.once(async () => {
        console.log("ScreenShare Stopped");
        var shareMsg = {
          type: "screenShare",
          data: "stop"
        };
        dataStreamPrivate.write(JSON.stringify(shareMsg));
        screenShareButton.disabled = false;
        screenShareInfo.style.display = "none";
      });

      // 画面共有の開始
      var shareMsg = {
        type: "screenShare",
        data: "start"
      };
      console.log("Send ScreenShare Start Message");
      dataStreamPrivate.write(JSON.stringify(shareMsg));
      screenShareButton.disabled = true;
      screenShareInfo.style.display = "block";
    };

    // ロビーに誰かが入った時
    robbyChannel.onMemberJoined.add(e => onRobbyMemberJoin(e.member));
    const onRobbyMemberJoin = member => {
      //console.log('login:', member );
    };

    //ロビーの誰かの情報がアップデートされたとき
    robbyChannel.onMemberMetadataUpdated.add(e => onRobbyMemberMetadataUpdated(e.member));
    const onRobbyMemberMetadataUpdated = member => {
      let memberMeta = JSON.parse(member.metadata);
      console.log('metadata updated:', memberMeta);
      if (memberMeta.callStatus == 'calling') {
        const callingButton = document.getElementsByName(memberMeta.name).item(0);
        callingButton.textContent = '***着信中*** ' + memberMeta.name + ' ***着信中***';
        callingButton.classList.add('callingGuest');
        if (userInfo.callStatus != 'talking') {
          ringTone.play();
        }
      } else {
        const callingButton = document.getElementsByName(memberMeta.name).item(0);
        callingButton.textContent = memberMeta.name;
        callingButton.classList.remove('callingGuest');
        ringTone.pause();
      }
    };

    // ロビーから誰かが退出した時
    robbyChannel.onMemberLeft.add(e => onRobbyMemberLeft(e.member));
    const onRobbyMemberLeft = member => {
      console.log("member has left:", member);
      robbyMembersButton();
    };

    // 既にロビーでPubられているものをSubる
    robbyChannel.publications.forEach(subscribeAndAttacheInRobby);
    // 新たにロビーに入ってきたPubをSubる
    robbyChannel.onStreamPublished.add(e => subscribeAndAttacheInRobby(e.publication));

    // ログインしたらログインボタンは非活性、ログアウトボタンは活性
    logInName.disabled = true;
    logInButton.disabled = true;
    logOutButton.disabled = false;
    _checkUserInfo();
  }; //-------------------------------------------------------------- ログインボタン処理時 末尾

  logOutButton.onclick = () => {
    //--------------------------------- ログアウトボタン処理
    // ログアウトしたらログインボタンを活性、ログアウトボタンは非活性
    logInName.disabled = false;
    logOutButton.disabled = true;
    logInButton.disabled = false;
    _checkUserInfo();
  }; //-------------------------------------------------------------- ログアウトボタン処理 末尾

  //---------------------------------------------------------------- ここからが起動時処理
  init();
})();
